import { ACTION_TYPES } from '../constants';

export default error => ({
  type: ACTION_TYPES.AUTH_VOD_ERROR,
  payload: {
    error
  }
});
